import { render, staticRenderFns } from "./Attestation.vue?vue&type=template&id=8cda88c6"
import script from "./Attestation.vue?vue&type=script&lang=js"
export * from "./Attestation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports